module.exports = __webpack_public_path__ + "static/Pt17-af6f6946fd63fa88b14ddae0ddfbf6e0.jpg";